"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _Image = _interopRequireDefault(require("../Image"));
var _LinkRaw = _interopRequireDefault(require("@commerce-ui/core2/LinkRaw"));
var _langLibrary = _interopRequireDefault(require("@deosite/helpers/langLibrary"));
var _Inspiration = _interopRequireDefault(require("@deosite/ui-entities/Inspiration"));
var _RouteContext = require("@deosite/lib/RouteContext");
var _getRouteFromUrl = _interopRequireDefault(require("@deosite/helpers/getRouteFromUrl"));
var __jsx = _react["default"].createElement;
var ArrowRightIcon = function ArrowRightIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.128 12.238l-2.976-2.975.848-.849 4.425 4.424L18 17.263l-.848-.849 2.976-2.976H1.576v-1.2h18.552z"
  }));
};
ArrowRightIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var InspirationCard = function InspirationCard(props) {
  var _props$inspiration = props.inspiration,
    mainImage = _props$inspiration.mainImage,
    thumbnails = _props$inspiration.thumbnails,
    title = _props$inspiration.title,
    cardLink = _props$inspiration.cardLink,
    influencerData = _props$inspiration.influencerData;
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  var _ref = influencerData ? influencerData : "",
    image = _ref.image,
    username = _ref.username;
  var translations = {
    by: (0, _langLibrary["default"])("by")
  };
  var routeFromUrl = (0, _getRouteFromUrl["default"])(cardLink);
  var route = routeFromUrl ? routeFromUrl : "category-page";
  var url = cardLink.lastIndexOf("/", 0) === 0 ? cardLink.slice(1) : cardLink;
  return __jsx(_Box["default"], {
    sx: {
      width: "100%",
      pb: "s7",
      position: "relative"
    }
  }, __jsx(_Box["default"], {
    sx: {
      width: "100%"
    }
  }, __jsx(_Image["default"], {
    sx: {
      width: "100%",
      height: ["250px", null, null, "375px"],
      aspectRatio: 1.333
    },
    image: mainImage,
    sizes: "(max-width: 1335px) and (min-width: 705px) 420px, 768px",
    mode: "cover"
  }), username !== undefined && __jsx(_Box["default"], {
    sx: {
      display: "inline-block",
      width: "60px",
      height: "60px",
      position: "absolute",
      top: "15px",
      left: "15px",
      zIndex: 1
    }
  }, __jsx(_Image["default"], {
    image: image,
    sx: {
      width: "54px",
      height: "54px",
      borderRadius: "50px",
      border: "3px",
      borderStyle: "solid",
      borderColor: "white",
      overflow: "hidden"
    },
    sizes: "500px"
  }))), __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      mt: "s7"
    }
  }, __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexDirection: "row",
      maxWidth: username !== undefined ? "70%" : "100%",
      color: "main"
    }
  }, __jsx(_Box["default"], {
    as: "h3",
    sx: {
      font: "heading3",
      pr: "s5"
    }
  }, title), __jsx(ArrowRightIcon, null)), username !== undefined && __jsx(_Box["default"], {
    as: "p",
    sx: {
      color: "main",
      font: "s",
      textAlign: "left"
    }
  }, translations.by + " ", __jsx(_Box["default"], {
    as: "span",
    sx: {
      font: "s_italic"
    }
  }, "@", username))), __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "nowrap",
      justifyContent: "flex-start",
      alignItems: "center",
      mt: "s7"
    }
  }, thumbnails && thumbnails.map(function (thumbnail, index) {
    return __jsx(_Image["default"], {
      image: thumbnail,
      key: index,
      sx: {
        width: ["67px", null, null, "80px"],
        height: ["67px", null, null, "80px"]
      },
      sizes: "100px"
    });
  })), __jsx(Link, {
    route: route,
    params: {
      url: url
    }
  }, __jsx(_LinkRaw["default"], {
    title: title,
    sx: {
      position: "absolute",
      width: "100%",
      height: "100%",
      top: "0",
      left: "0",
      zIndex: "1"
    }
  })));
};
var _default = InspirationCard;
exports["default"] = _default;